// Earthy Genova theme scripts
(function () {
  'use strict';

  // Overlays: mobile menu + search modal
  document.querySelectorAll('[data-open]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var target = document.getElementById(trigger.getAttribute('data-open'));
      if (target) {
        target.classList.add('is-open');
        var input = target.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  });

  document.querySelectorAll('[data-overlay]').forEach(function (overlay) {
    overlay.addEventListener('click', function (event) {
      var panel = overlay.querySelector('[data-overlay-panel]');
      if (!panel.contains(event.target) || event.target.closest('[data-close]')) {
        overlay.classList.remove('is-open');
      }
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      document.querySelectorAll('[data-overlay].is-open').forEach(function (overlay) {
        overlay.classList.remove('is-open');
      });
    }
  });

  // Product page: gallery thumbs
  var mainImage = document.getElementById('ProductMainImage');
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImage) return;
      mainImage.src = thumb.getAttribute('data-thumb');
      document.querySelectorAll('[data-thumb]').forEach(function (other) {
        other.setAttribute('aria-current', other === thumb ? 'true' : 'false');
      });
    });
  });

  // Product page: quantity stepper
  var qtyInput = document.querySelector('[data-qty-input]');
  document.querySelectorAll('[data-qty]').forEach(function (button) {
    button.addEventListener('click', function () {
      if (!qtyInput) return;
      var step = parseInt(button.getAttribute('data-qty'), 10);
      var next = (parseInt(qtyInput.value, 10) || 1) + step;
      qtyInput.value = next < 1 ? 1 : next;
    });
  });

  // Product page: variant change updates price + button state
  var select = document.querySelector('[data-variant-select]');
  if (select) {
    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      var priceEl = document.querySelector('[data-price]');
      if (priceEl && option.dataset.price) priceEl.textContent = option.dataset.price;
      var submit = document.querySelector('#ProductForm button[type="submit"]');
      if (submit) {
        submit.disabled = option.disabled;
        submit.textContent = option.disabled ? 'Sold Out' : 'Add to Cart';
      }
    });
  }
})();
